module.exports = __webpack_public_path__ + "media/images/bg-490c5aa76b6702f0f0c8f30bc8b72feb.png";